import React, { useState, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useComponentVisibility } from '../../../../../hooks/useComponentVisibility';
import { LoadingSkeleton } from '@eventbrite/legacy-infra.loading-skeleton';
import { getEmbedUrl } from '../utils/videoUtils';
import styles from './LazyVideo.module.scss';

export interface LazyVideoProps {
  src: string;
  altText?: string;
  className?: string;
  style?: React.CSSProperties;
  priority?: boolean;
}

export const LazyVideo: React.FC<LazyVideoProps> = ({ src, altText, className, style, priority = false }) => {
  const { formatMessage } = useIntl();
  const [shouldLoad, setShouldLoad] = useState(priority);

  const handleVisible = useCallback(() => {
    setShouldLoad(true);
  }, []);

  const ref = useComponentVisibility(handleVisible, {
    threshold: 0.1,
    rootMargin: '50px',
  });

  const shouldLoadVideo = priority || shouldLoad;
  const embedUrl = getEmbedUrl(src);

  return (
    <div ref={ref} className={className} style={style}>
      {shouldLoadVideo ? (
        <div className={styles.videoContainer}>
          <iframe
            src={embedUrl}
            allowFullScreen
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            title={formatMessage({ id: 'Video content' })}
            style={{ border: 'none' }}
          >
            {altText}
          </iframe>
        </div>
      ) : (
        <LoadingSkeleton height={315} />
      )}
    </div>
  );
};
